module.exports = __webpack_public_path__ + "img/notification_off.2c7e36e4.svg";